import { type InsuranceCorporateIdentity } from "../types";

export function BahnBKKLogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_30_93)">
        <path
          d="M158.699 251.031C160.027 254.921 157.951 257.321 154.712 257.321C152.718 257.321 151.306 255.997 150.393 253.431L145.991 241.844H121.405L117.003 253.431C116.089 255.997 114.594 257.321 112.518 257.321C109.445 257.321 107.285 254.838 108.614 251.113L126.14 204.02C127.385 200.461 129.877 198.723 133.698 198.723C137.519 198.723 140.093 200.461 141.339 204.02L158.699 251.031ZM133.864 207.165H133.615L123.731 234.809H143.748L133.864 207.165Z"
          fill="#353438"
        />
        <path
          d="M217.504 203.689V252.769C217.504 255.666 215.677 257.404 212.936 257.404C210.278 257.404 208.451 255.748 208.451 252.769V232.243H178.466V252.769C178.965 258.811 168.832 258.976 169.413 252.769V203.689C168.832 197.564 178.965 197.564 178.466 203.689V224.711H208.451V203.689C208.451 200.71 210.278 199.054 212.936 199.054C215.677 199.054 217.504 200.71 217.504 203.689Z"
          fill="#353438"
        />
        <path
          d="M278.469 203.689V251.61C278.469 255.252 276.393 257.404 272.738 257.404C270.412 257.404 268.419 256.079 266.841 253.514L240.013 212.793H239.847L240.262 231.498V252.686C240.262 255.666 238.352 257.321 235.611 257.321C232.953 257.321 231.209 255.666 231.209 252.686V204.682C231.209 201.123 233.119 199.054 236.691 199.054C239.016 199.054 241.01 200.296 242.588 202.696L269.665 243.334H269.831L269.416 224.463V203.689C269.416 200.71 271.243 199.054 273.984 199.054C276.642 199.054 278.469 200.71 278.469 203.689Z"
          fill="#353438"
        />
        <path
          d="M80.9557 199.22C91.5042 199.22 98.398 205.013 98.398 214.531C98.398 221.897 94.162 226.284 89.5108 227.608C95.7402 228.85 100.558 233.65 100.558 241.513C100.558 246.396 98.8133 250.286 95.4079 253.1C92.0025 255.831 87.8496 257.238 82.9491 257.238H59.0283C56.1212 257.238 54.7092 255.831 54.7092 252.934V203.606C54.7092 200.792 56.1212 199.303 59.0283 199.22H80.9557ZM63.6796 206.669V224.38H80.4574C85.6901 224.38 89.0955 220.739 89.0955 215.69C89.0955 210.145 85.0256 206.586 80.0421 206.669H63.6796ZM63.6796 231.25V249.706H81.5371C87.1021 249.706 91.0889 246.065 91.0889 240.52C91.0889 235.305 87.6004 231.25 81.6202 231.25H63.6796Z"
          fill="#353438"
        />
        <path
          d="M324.733 199.22C335.281 199.22 342.175 205.013 342.175 214.531C342.175 221.897 337.939 226.284 333.288 227.608C339.517 228.85 344.334 233.65 344.334 241.513C344.334 246.396 342.59 250.286 339.185 253.1C335.779 255.831 331.626 257.238 326.726 257.238H302.805C299.898 257.238 298.486 255.831 298.486 252.934V203.606C298.486 200.792 299.898 199.303 302.805 199.22H324.733ZM307.456 206.669V224.38H324.234C329.467 224.38 332.872 220.739 332.872 215.69C332.872 210.145 328.802 206.586 323.819 206.669H307.456ZM307.456 231.25V249.706H325.314C330.879 249.706 334.866 246.065 334.866 240.52C334.866 235.305 331.377 231.25 325.397 231.25H307.456Z"
          fill="white"
        />
        <path
          d="M400.648 250.12L379.551 223.47L397.243 206.007C398.156 205.096 398.572 204.268 398.572 203.192C398.572 201.206 396.744 199.054 394.087 199.054C392.841 199.054 391.927 199.468 391.179 200.378L364.85 226.946L364.601 226.863L364.85 203.689C365.348 197.564 355.215 197.564 355.797 203.689V252.769C355.298 258.893 365.431 258.893 364.85 252.769V237.871L373.239 229.677L393.256 255.5C393.837 256.328 394.917 257.321 396.91 257.321C399.818 257.321 401.645 254.921 401.645 252.686C401.645 251.776 401.396 251.031 400.648 250.12Z"
          fill="white"
        />
        <path
          d="M457.294 250.12L436.197 223.47L453.889 206.007C454.802 205.096 455.218 204.268 455.218 203.192C455.218 201.206 453.39 199.054 450.732 199.054C449.487 199.054 448.573 199.468 447.825 200.378L421.413 226.946L421.164 226.863L421.413 203.689C421.911 197.564 411.778 197.564 412.359 203.689V252.769C411.861 258.893 421.994 258.893 421.413 252.769V237.871L429.802 229.677L449.819 255.5C450.4 256.328 451.48 257.321 453.473 257.321C456.38 257.321 458.208 254.921 458.208 252.686C458.291 251.776 457.959 251.031 457.294 250.12Z"
          fill="white"
        />
        <path
          d="M256.458 315.008C170.908 315.008 20.9874 281.902 20.9874 281.902C21.0705 284.219 23.0639 286.123 39.5095 291.254C70.3242 300.938 158.449 331.147 256.458 331.147C354.468 331.147 442.51 300.938 473.407 291.254C489.853 286.123 491.846 284.219 491.929 281.902C491.929 281.819 342.009 315.008 256.458 315.008Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_30_93">
          <rect width="512" height="512" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export const BahnBKK: InsuranceCorporateIdentity = {
  id: "bahn-bkk",
  name: "Bahn BKK",
  logo: BahnBKKLogo,
  backgroundColor: "#FFB81C",
  textColor: "#353438",
  wildcard: "bahn",
  type: "statutory",
};
